module.exports = __webpack_public_path__ + "static/media/FACET_TRACEMARK.933111c2.png";